import { colorConstants } from 'config/colorConstants';
import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const PositiveUpArrow = ({ stroke = colorConstants.limeGreen }: { stroke?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.86335 0L9.07514 6.75H0.651566L4.86335 0Z" fill={stroke} />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.86335 0L9.07514 6.75H0.651566L4.86335 0Z" fill={stroke} />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.86335 0L9.07514 6.75H0.651566L4.86335 0Z" fill={stroke} />
        </svg>
    );
};

export default PositiveUpArrow;
